import React from 'react';
import ForgotPassword from '../../@jumbo/components/Common/authComponents/ForgotPassword';

const ForgotPasswordPage = () => {
    return (
        <ForgotPassword variant="standard" wrapperVariant="bgColor" />
    )
    }
export default ForgotPasswordPage;
